<template>
  <div class="validation-tool-tip fade-in -helper--flex column">
    <span class="tt-arrow" />
    <div
      v-for="item in data"
      :key="item.id"
      class="tt-item -helper--flex align-center"
    >
      <span
        :style="{ backgroundColor: item.isValid ? '#0E5CF4' : '#b2b2b2' }"
      />
      <p>{{ item.content }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ['data'],
}
</script>



// WEBPACK FOOTER //
// src/components/globalUiComponents/toolTips/ValidationToolTip.vue